module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-my-601fb748c791aa82e7b41edf5c6932fb.svg";